import { CheckOutlined, ClockCircleOutlined, CloseOutlined, PlusOutlined, SyncOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';
import AnyBodyImage from 'components/AnyBodyImage';
import { get } from 'lodash';
import { IBookingV4ServiceItem, IBookingV4StaffItem } from '../types';
import { getStaffRangeLabel } from './helpers';
import ServiceRow from './ServiceRow';
import {
  AddServiceButton,
  IconButton,
  RequestButton,
  ServiceList,
  StaffBlockBox,
  StaffRow,
} from './styles';

type Props = {
  staff: IBookingV4StaffItem;
  onChangeStaff: () => void;
  onPickTime: () => void;
  onToggleRequest: () => void;
  onRemoveStaff: () => void;
  onAddService: () => void;
  onRemoveService: (serviceId: string) => void;
  onEditService: (service: IBookingV4ServiceItem) => void;
};

const StaffBlock = ({
  staff,
  onChangeStaff,
  onPickTime,
  onToggleRequest,
  onRemoveStaff,
  onAddService,
  onRemoveService,
  onEditService,
}: Props) => {
  const rangeLabel = getStaffRangeLabel(staff);
  return (
    <StaffBlockBox>
      <StaffRow>
        <div className="staff-info">
          {staff.anybody ? (
            <AnyBodyImage width={40} height={40} />
          ) : (
            <Avatar className="avatar" src={staff.staffAvatar}>
              {get(staff.staffName, [0], '')}
            </Avatar>
          )}
          <span className="name">{staff.anybody ? 'Anybody' : staff.staffName}</span>
          <IconButton type="button" className="small" onClick={onChangeStaff}>
            <SyncOutlined />
          </IconButton>
        </div>
        <div className="action">
          {!!rangeLabel && (
            <div className="time" onClick={onPickTime}>
              <ClockCircleOutlined />
              <span>{rangeLabel}</span>
            </div>
          )}
          <RequestButton type="button" data-active={staff.requestStaff} onClick={onToggleRequest}>
            <span className="check">
              <CheckOutlined />
            </span>
          </RequestButton>
          <IconButton type="button" className="delete" onClick={onRemoveStaff}>
            <CloseOutlined />
          </IconButton>
        </div>
      </StaffRow>

      {!!staff.services.length && (
        <ServiceList>
          {staff.services.map((service) => (
            <ServiceRow
              key={service.id}
              service={service}
              onRemove={() => onRemoveService(service.id)}
              onEditTime={() => onEditService(service)}
            />
          ))}
        </ServiceList>
      )}

      <AddServiceButton type="button" onClick={onAddService}>
        <PlusOutlined />
        <span>Add Service</span>
      </AddServiceButton>
    </StaffBlockBox>
  );
};

export default StaffBlock;
